import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PagoManualDialog } from "@/components/PagoManualDialog";
import { Banknote } from "lucide-react";

const hoy = () => new Date().toISOString().slice(0, 10);

export const CobrosManuales = () => {
  const [cobros, setCobros] = useState([]);
  const [renovar, setRenovar] = useState(null);

  const cargar = () => api.get("/cobros-manuales", { params: { dias: 15 } })
    .then(({ data }) => setCobros(data)).catch(() => setCobros([]));
  useEffect(() => { cargar(); }, []);

  if (cobros.length === 0) return null;

  return (
    <Card className="rounded-2xl p-6 border-border shadow-sm mb-8" data-testid="card-cobros-manuales">
      <div className="flex items-center gap-2 mb-2">
        <Banknote className="h-5 w-5 text-primary" />
        <h3 className="font-display text-lg font-bold">Cobros manuales por vencer</h3>
      </div>
      <p className="text-xs text-muted-foreground mb-5">
        Pagos en efectivo o transferencia que hay que renovar en los próximos 15 días
      </p>
      <div className="divide-y divide-border">
        {cobros.map((c) => (
          <div key={c.alumno_id} className="py-3.5 flex items-start justify-between gap-4"
            data-testid={`cobro-manual-${c.alumno_id}`}>
            <div className="min-w-0">
              <p className="font-semibold text-sm">
                {c.alumno} <span className="text-muted-foreground font-normal">{c.matricula}</span>
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                {c.sede} · {c.plan || "sin plan"} · {Number(c.importe).toFixed(2)} € · {c.metodo}
                {c.tutor ? ` · ${c.tutor}` : ""}{c.telefono ? ` · ${c.telefono}` : ""}
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <Badge variant={c.dias <= 0 ? "destructive" : "outline"} className="rounded-full">
                {c.dias <= 0 ? `vencido (${c.vence})` : `en ${c.dias} días`}
              </Badge>
              <Button size="sm" variant="outline" className="rounded-full font-semibold"
                onClick={() => setRenovar(c)} data-testid={`renovar-cobro-${c.alumno_id}`}>
                Renovar
              </Button>
            </div>
          </div>
        ))}
      </div>

      {renovar && (
        <PagoManualDialog open onOpenChange={(v) => !v && setRenovar(null)}
          alumnoId={renovar.alumno_id} sedeId={renovar.sede_id}
          titulo={`Renovar el pago de ${renovar.alumno}`}
          inicial={{
            plan_id: renovar.plan_id || "", metodo: renovar.metodo || "efectivo",
            fecha_pago: hoy(), fecha_inicio: renovar.proximo_inicio || hoy(),
            importe: renovar.importe ? String(renovar.importe) : "",
          }}
          onHecho={() => { setRenovar(null); cargar(); }} />
      )}
    </Card>
  );
};
